import React, { useState } from "react";
import "../../../style/landing.css";
import { waitlist } from "../constants/Constants_Functions";
import { landing_status } from "../constants/Constants_Var";
import img1 from "../../../image/Frame 20.webp";
import img2 from "../../../image/Frame 21.webp";
import img3 from "../../../image/Gmail inbox template 1.webp";
import hubspot_logo from "../../../image/logos_hubspot.webp";
import img4 from "../../../image/Frame 25.webp";
import img5 from "../../../image/Frame 26.webp";
import logos_openai from "../../../image/logos_openai.webp";
import shadow from "../../../image/shadow-card.webp";
import WaitlistSection from "../waitlist/WaitlistSection";
import AOS from "aos";
import "aos/dist/aos.css";

import Navbar from "../navbar/Navbar";

const Heroes = () => {
  const [email, setEmail] = useState("");

  AOS.init({
    startEvent: "DOMContentLoaded",
    initClassName: "aos-init",
    animatedClassName: "aos-animate",
    debounceDelay: 50,
    throttleDelay: 99,
    offset: 220,
    delay: 100,
    duration: 1000,
    easing: "ease",
    once: false,
  });

  return (
    <>
      <div className="lp-hero-container">
        <div className="lp-container">
          <Navbar />

          <h1 className="lp-heading">
            Your All-in-One Platform for <br />
            <span style={{ color: "#00BFA6" }}>Personalized Newsletters</span>
          </h1>

          <p className="lp-heading-desc">
            Personalize your newsletters, engage readers, and achieve your{" "}
            <br />
            communication goals effortlessly
          </p>

          <div className="lp-wailist-section">
            <img
              src={img2}
              alt="email-icon | Newslettrai"
              className="side-img"
            />

            <WaitlistSection
              name={"inputwaitlist5"}
              email={email}
              setEmail={setEmail}
              waitlist={() =>
                waitlist(email, setEmail, landing_status.waitlist)
              }
            />

            <img
              src={img1}
              alt="star-icon | Newslettrai"
              style={{ marginTop: "-80px" }}
              className="side-img"
            />
          </div>

          <img src={img3} alt="Newslettrai - hero-image" className="hero-img" />
        </div>
      </div>
      <img
        src={shadow}
        alt="Newslettrai shadow-image"
        className="hero-shadow-img"
      />

      <h2 className="lp-product-heading" style={{ margin: "0px" }}>
        Intergrations with
      </h2>

      <div className="lp-container">
        <div className="intergrations-logos">
          <img src={hubspot_logo} alt="Newslettrai - hubspot logo" />
          <img src={img4} alt="Newslettrai - mailchimp logo" />
          <img src={img5} alt="Newslettrai - beehiiv logo" />
          <img src={logos_openai} alt="Newslettrai - chatgpt logo" />
        </div>
      </div>

      <p className="inte-desc">
        {" "}
        <span style={{ color: "#0074D9" }}>
          All-in-One Newsletter Solution.
        </span>{" "}
        <span style={{ color: "#32323280" }}> Our platform simplifies</span>{" "}
        <br />
        email marketing <span style={{ color: "#32323280" }}>with</span>{" "}
        AI-powered{" "}
        <span style={{ color: "#32323280" }}>
          tools and sleek <br /> design, giving you effortless control over your
        </span>{" "}
        <br /> campaigns <span style={{ color: "#32323280" }}>and</span>{" "}
        personalized content.
      </p>
    </>
  );
};

export default Heroes;
